<template>
  <div class="yhgl">
    <div class="thrkBody">
      <div class="bodyHeader">
        <el-form
          ref="search"
          :inline="true"
          :model="searchForm"
          style="width: 100%; padding: 10px 20px; margin-bottom: 20px"
          label-position="left"
        >
          <el-form-item label="IP" prop="ip">
            <el-input
              v-model="searchForm.ip"
              placeholder="IP"
            />
          </el-form-item>
          <el-form-item label="登录名称" prop="loginName">
            <el-input
              v-model="searchForm.loginName"
              placeholder="登录名称"
            />
          </el-form-item>
          <el-form-item label="手机号码" prop="phonenumber">
            <el-input
              v-model="searchForm.phonenumber"
              placeholder="手机号码"
            />
          </el-form-item>
          <el-form-item label="用户类别" prop="userType">
            <el-input
              v-model="searchForm.userType"
              style="width: 100px;"
              placeholder="用户类别"
            />
          </el-form-item>
          <el-form-item>
            <div style="display: flex; margin-left: 20px">
              <el-button
                type="primary"
                icon="el-icon-search"
                round
                size="small"
                @click="searchHandle"
              >搜索</el-button>
              <el-button
                icon="el-icon-refresh-left"
                style="width: 90px; height: 39px"
                round
                size="small"
                @click="reset"
              >重置</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div class="thrkRight">
        <div class="bodyTable">
          <!-- <div class="thrkLeft1">
            <el-tree
              :data="data"
              show-checkbox
              node-key="id"
              :default-expanded-keys="[2, 3]"
              :default-checked-keys="[5]"
            >
            </el-tree>
          </div> -->
          <div class="thrkLeft2">
            <!-- <div class="addmessheader">
              <el-button
                type="primary"
                class="addmess"
                size="mini"
                icon="el-icon-upload2"
              >
                导出</el-button
              >
              <el-button type="primary" size="mini" icon="el-icon-delete"
                >清空</el-button
              >
            </div> -->
            <el-table
              border
              :data="tableData"
              :header-cell-style="{
                'text-align': 'center',
                background: '#f4f4f4',
              }"
              :cell-style="{ 'text-align': 'center' }"
              style="width: 100%"
            >
              <el-table-column
                prop="loginName"
                label="登录名称"
                align="center"
              />
              <el-table-column
                prop="accessToken"
                show-overflow-tooltip
                label="访问token"
                align="center"
              />
              <el-table-column
                prop="userId"
                label="用户主键"
                align="center"
              />
              <el-table-column
                prop="clientId"
                label=" 客户端id"
                align="center"
              />

              <el-table-column
                prop="ip"
                label="IP"
                align="center"
              />
              <el-table-column
                prop="userType"
                label="用户类型"
                align="center"
              />
              <el-table-column
                prop="phonenumber"
                label="手机号"
                align="center"
              />

            </el-table>

            <el-pagination
              background
              layout="prev,pager,next,jumper,total,sizes"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pagesize"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
            />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="DialogVisible"
      width="500px"
      center
      title="操作日志详细"
      custom-class="czrzxx"
      label-width="80px"
    >
      <el-form ref="otherQyxxForm" :model="otherQyxxForm">
        <el-form-item label="操作模块:">
          <el-input
            v-model="otherQyxxForm.czmk"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="登录信息:">
          <el-input
            v-model="otherQyxxForm.dlxx"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="请求地址:">
          <el-input
            v-model="otherQyxxForm.qqdz"
            placeholder="请输入"
          /> </el-form-item><el-form-item label="请求方式:">
          <el-input
            v-model="otherQyxxForm.qqfs"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="操作方法:">
          <el-input
            v-model="otherQyxxForm.czff"
            placeholder="请输入"
          /> </el-form-item><el-form-item label="用户性别:">
          <el-input
            v-model="otherQyxxForm.yhxb"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item label="请求参数:">
          <el-input
            v-model="otherQyxxForm.qqcs"
            type="textarea"
            :rows="6"
            style=""
            placeholder="请输入"
            resize="none"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-preventReClick
          type="primary"
          style="background: #4170ff; border-color: #4170ff"
          @click="sureDelete"
        >确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getOnlineUser } from '@/assets/js/system'
export default {
  data() {
    return {
      currentPage: 1, // 当前页
      pagesize: 10, // 每页的数据条数
      total: 0,
      data: [],
      tableData: [],
      searchForm: {
        ip: '', // --当前ip
        loginName: '', //   --登录名称
        phonenumber: '', // --手机号码
        userType: '' // --用户类别
      },
      czlxList: [
        {
          label: '类型1',
          value: 0
        },
        {
          label: '类型2',
          value: 1
        }
      ],
      DialogVisible: false,
      otherQyxxForm: {
        czmk: '',
        dlxx: '',
        qqdz: '',
        qqfs: '',
        czff: '',
        yhxb: '',
        qqcs: ''
      }
    }
  },

  watch: {},
  created() { },
  mounted() {
    this.loadData()
  },
  beforeDestroy() { },
  methods: {
    reset() {
      this.$refs['search'].resetFields()
      this.searchHandle()
    },
    loadData() {
      getOnlineUser({
        page: this.currentPage,
        size: this.pagesize,
        param: this.searchForm
      }).then(res => {
        if (res.status === 200 && res.data.code === '000000') {
          // 成功
          this.tableData = res.data.data.rows
          this.total = res.data.data.total
        }
      })
    },
    // 编辑
    editItem(row) {
      this.DialogVisible = true
    },
    sureDelete() {
      this.DialogVisible = false
    },
    searchHandle() {
      this.currentPage = 1
      this.loadData()
    },
    // 当前页码改变时
    handleCurrentChange(val) {
      this.currentPage = val // 当前页
      this.loadData()
    },
    // 10条/页改变时
    handleSizeChange(val) {
      this.pagesize = val
      this.loadData()
    }
  }
}
</script>
<style scoped lang='less'>
.yhgl {
  .thrkBody {
    margin: 0 auto;
    .bodyHeader {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      margin-bottom: 11px;
      margin-top: 30px;
      display: flex;
      align-items: center;
      padding: 30px 0 0 0;
      border-radius: 5px;
      .el-form-item {
        margin-right: 20px;
        // width: 22%;
        &:nth-child(4) {
          margin-right: 0px;
        }
        // &:nth-child(5) {
        //   width: 50%;
        //   .el-date-editor {
        //     width: 40%;
        //   }
        // }
        .el-form-item__content {
          display: flex;
        }
      }

      .el-button--primary {
        color: #fff;
        background: #4170ff;
        border-color: #4170ff;
        width: 90px;
        height: 39px;
      }
    }
    .thrkRight {
      width: 95%;
      background-color: #fff;
      margin: 0 auto;
      padding-top: 40px;
      padding-bottom: 57px;
      .bodyTable {
        width: calc(100% - 40px);
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        .thrkLeft1 {
          width: 156px;
        }
        .thrkLeft2 {
          // width: calc(100% - 166px);
          width: 100%;
          .addmessheader {
            background: #f4f4f4;
            .addmess {
              margin: 12px 0 12px 8px;
            }
          }
          .el-button--primary {
            color: #fff;
            background: #4170ff;
            border-radius: 3px;
            border-color: #4170ff;
          }
        }
      }
      .el-pagination__total {
        margin-left: 8px;
      }
      .el-pagination {
        padding: 10px 0;

        border: 1px solid #ebeef5;
        border-top: 0;
      }
      .el-pager {
        .number {
          background: #4170ff;
          border-color: #4170ff;
        }
      }
    }
  }
}
/deep/.el-dialog__header {
  .header-title {
    text-align: left;
  }
}
/deep/.el-dialog__body {
  padding: 0;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #4170ff !important;
  color: #fff;
}
/deep/.czrzxx {
  // padding: ;
  .el-dialog__body {
    padding: 20px 80px 20px;
    .el-form-item__content {
      display: flex;
    }
  }
}
</style>
